import { useEffect, useRef, useState } from 'react';

export const useDetectVisibility = () => {
  const [visible, setVisible] = useState(true);
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    /** @type {NodeJS.Timeout | null} */
    let timer = null;
    const detectFreeze = () => {
      let shown = true;
      const rect = document.body.getBoundingClientRect();

      if (rect.width === 0 || rect.height === 0) {
        shown = false;
      }

      setExpanded(shown);
      timer = setTimeout(detectFreeze, 100);
    };

    detectFreeze();

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  });

  useEffect(() => {
    const checkVisibility = () => {
      const shown = document?.visibilityState === 'visible';
      setVisible(shown);
    };
    document.addEventListener('visibilitychange', checkVisibility);

    checkVisibility();

    return () => {
      document.removeEventListener('visibilitychange', checkVisibility);
    };
  }, []);

  return [visible && expanded];
};
